// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductButton_container__1rO4K","product-name-container":"ProductButton_product-name-container__O75il","product-name":"ProductButton_product-name__1FAdM"};